module.exports = __webpack_public_path__ + "img/anli.a54ba6f3.png";